/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFixedTimeCall.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/fixed-time-call";

export class AutogenModelFixedTimeCall<RowType extends ModelRow> extends Endpoint<RowType, RowFixedTimeCallFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFixedTimeCall extends ModelRow<RowFixedTimeCallFields> {
	constructor(values?: Partial<RowFixedTimeCallFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFixedTimeCallFields {
	checkcall_sched_id: string;
	company_id: string;
	fixed_time: string;
	friday: string;
	id: string;
	monday: string;
	saturday: string;
	sunday: string;
	thursday: string;
	tuesday: string;
	wednesday: string;
}

